<template>
    <div class="container-fluid">
        <div class="row">
            <div class="col-sm-6 mb-5">
                <label for="selectCalendar" class="form-label">Select a Calendar</label>
                <select id="selectCalendar" class="form-select" v-model="selectedCalendarId" aria-label="Select a calendar">
                    <option :value="0">-- Select a Calendar --</option>
                    <option v-for="calendar in calendars" :value="calendar.Id">{{ calendar.Description }}</option>
                </select>
            </div>
        </div>
        <div v-if="selectedCalendar" class="row">
            <div class="col-sm-6">
                <div class="h2">{{ selectedCalendar.Description }}</div>
                <calendar-list widget-id="calendar-list" :calendar-name="selectedCalendar.Name" :json-url="props.calendarByNameUrl"
                               :shown-events="1" :event-id="props.eventId"></calendar-list>
            </div>
            <div class="col-sm-6">
                <calendar-widget widget-id="calendar-wigdet" :calendar-id="selectedCalendar.Id" :json-url="props.calendarMonthUrl"></calendar-widget>
            </div>
        </div>
    </div>
</template>

<script setup>
    import { ref, computed, onMounted } from 'vue';
    import CalendarList from '../../components/vue/calendar/calendar-list.vue';
    import CalendarWidget from '../../components/vue/calendar/calendar-widget.vue';

    const props = defineProps({
        calendars: {
            type: Array,
            required: true
        },
        calendarId: {
            type: Number
        },
        eventId: {
            type: Number
        },
        calendarMonthUrl: {
            type: String
        },
        calendarByNameUrl: {
            type: String
        }
    });

    const selectedCalendarId = ref(0);
    const selectedCalendar = computed(() => _.find(props.calendars, c => c.Id === selectedCalendarId.value));

    onMounted(() => {
        if (props.calendarId) {
            selectedCalendarId.value = props.calendarId;
        }
    })
</script>